import React from 'react';
import smLogo from '../assets/images/SportMinglePrimaryLogo.png'
import ThemeSwitcher from './ThemeSwitcher'

const Footer = () => {
    return (
        <div className='root-dashboard-footer' data-testid='root-dashboard-footer'>
            <hr className='footer-line' />
            <div className='root-dashboard-footer-content'>
                <img src={smLogo} alt="SportMingle" />
                <p>© {new Date().getFullYear()} SportMingle. All rights reserved.</p>
                <ThemeSwitcher />
           </div>
        </div>
    )
}

export default Footer
